import ReactDOM from 'react-dom';
import App from './App.js'

import './index.css';

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
